import type { PaginatedApi, ApiArgs } from '@api/types';
import { getRequest } from '@helpers/api';

import { type JurisdictionApi } from './types';

/* Fetch a list of jurisdictions for a specific entity */
export const fetchJurisdictions: PaginatedApi<ApiArgs, JurisdictionApi> = ({ limit, offset }) =>
  getRequest('countries/taxableJurisdictions/', {
    limit,
    offset,
  });
